import { Toaster as Sonner, type ToasterProps } from 'sonner';
import { useTheme } from '../../hooks/useTheme.js';

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme } = useTheme();

  return <Sonner theme={theme} {...props} />;
};

export { Toaster };
